import { IBreakpoints } from '../interfaces'

export const breakpoints: IBreakpoints<number> = {
  xxs: 375,
  xs: 550,
  sm: 768,
  md: 1024,
  lg: 1440
}
